{"id":"Cart.ItemsListSummaryBox","prefabs":{"default":{"children":[{"component":"Cart.ItemsListSummaryBox","options":"options:*"}]}}}